import { useEffect, useState } from "react";
import { removeEmojis } from "../../../../utils/stringUtils";

export const useCategoryForm = (initialName: string, initialType: string, error: boolean, open: boolean, initialDisplayOrder?: number) => {
  const [categoryName, setCategoryName] = useState(initialName);
  const [type, setType] = useState(initialType);
  const [hasError, setHasError] = useState(error);
  const [displayOrder, setDisplayOrder] = useState(initialDisplayOrder ? String(initialDisplayOrder) : "");

  useEffect(() => {
    setCategoryName(initialName);
    setType(initialType);
    setHasError(error);
    setDisplayOrder(initialDisplayOrder ? String(initialDisplayOrder) : "");
  }, [initialName, initialType, error, open, initialDisplayOrder]);

  // Change to accept string instead of event
  const handleCategoryNameChange = (value: string) => {
    let sanitized = removeEmojis(value).slice(0, 40);
    setCategoryName(sanitized.toUpperCase());
    setHasError(false);
  };

  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setType(event.target.value);
    setHasError(false);
  };

  const handleDisplayOrderChange = (value: string) => {
    setDisplayOrder(value);
  };

  const resetForm = () => {
    setCategoryName("");
    setType("");
    setHasError(false);
    setDisplayOrder("");
  };

  return {
    categoryName,
    type,
    displayOrder,
    hasError,
    setHasError,
    handleCategoryNameChange,
    handleTypeChange,
    handleDisplayOrderChange,
    resetForm,
  };
};
